import React from "react"
import Layout from "../components/Layout.js"
import Hero from "../components/pricing/Hero.js"
import PricingTable from "../components/pricing/PricingTable.js"
import Faq from "../components/pricing/Faq.js"
import Footer from "../components/index/Footer.js"
import FooterContact from "../components/index/FooterContact.js"

export default () => (
  <Layout>
    <Hero />
    <PricingTable />
    <Faq />
    <FooterContact />
    <Footer />
  </Layout>
)
